export default __webpack_public_path__ + "static/media/surveyWhite.715e7457.png";